export enum EActiveDomains {
  B2B = 'b2b',
  Dev = 'development',
  External = 'external-assistance',
  NotFound = 'not-found',
}
